<template>
  <div>
    <v-layout row container justify-center>
      <observaciones-pagos ref="observaciones" class="wide" :canAdd="canAdd"
      :pagoId="pagoId" :canEdit="canEdit" @observacionCreada="$emit('observacionCreada')"/>
    </v-layout>
  </div>

</template>

<script>
import ObservacionesPagos from './ObservacionesPagos'
export default {
  components: {
    ObservacionesPagos
  },
  props: {
    pagoId: [Number, String],
    canEdit: Boolean,
    canAdd: Boolean,
    tieneNotificaciones: Boolean
  },
  data () {
    return {
      markAsReadPath: `pago/${this.pagoId}/observaciones/read`
    }
  },

  methods: {
    marcarComoLeidas () {
      if (this.tieneNotificaciones) {
        this.axios
          .put(this.markAsReadPath)
          .then(response => {})
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
          })
      }
    }
  },

  created () {
    this.marcarComoLeidas()
  }
}
</script>
<style scoped>
  .subheadline {
    color: lightslategray;
    font-size: 1.6em;
    color: rgb(60, 145, 197);
    padding-top: 1.5em;
    margin-top: 2em;
  }
  .wide {
      width: 100%;
    }
</style>
